import axios from 'axios';
import { getUrl } from '../../MIS/Global';


const api = axios.create({
  baseURL: getUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
});

const apiFormData = axios.create({
  baseURL: getUrl(),
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

export const registerAccount = async (data) => {
  try {
    const response = await apiFormData.post('user-login/',data);    
    return response.data;
  } catch (error) {   
    // console.log(error)
    throw new Error('Something went wrong. Please try again.');
  }
};

export const statusUpdate = async (data) => {
  try {
    const response = await api.patch('user-login/',data);    
    return response.data;
  } catch (error) {   
    // console.log(error)
    throw new Error('Something went wrong. Please try again.');
  }
};

export const getUser = async (data) => {
  try {
    const queryParams = new URLSearchParams(data).toString();
    const response = await api.get(`user-login/?${queryParams}`);    
    return response.data;
  } catch (error) {   
    // console.log(error)    
    throw new Error('Something went wrong. Please try again.');
  }
};


export default {
  registerAccount,
  getUser,
  statusUpdate,
};